export default {
  methods: {
    _mixin_routing_navigateTo(path, props) {
      this.$emit('navigate', {
        path,
        props,
      })
    },
  },
}
